<template>
  <div>
    <app-header/>
    <slot></slot>
  </div>
</template>

<script>
import Header from '../components/appSetting/components/Header'
export default {
  name: 'setting',
  components: {
    appHeader: Header
  },
  mounted () {
    $('body').removeClass('bg-white')
  },
  beforeCreate () {
    if (localStorage.locale) this.$i18n.locale = localStorage.locale
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/setting.vue